<template>
  <div>
    <div
      class="management-philosophy"
      v-for="(item, index) in card"
      :key="index"
    >
      <div class="management-philosophy_blog-card">
        <div class="management-philosophy_blog-card-text">
          <h1 class="management-philosophy_blog-card-text-title">
            {{ item.title }}
          </h1>
          <div>
            <p class="management-philosophy_blog-card-text-description">
              {{ item.sub_title }}
            </p>
            <p class="management-philosophy_blog-card-text-description">
              {{ item.sub_title_2 }}
            </p>
          </div>
        </div>
        <div class="management-philosophy_blog-card-meta">
          <img
            class="management-philosophy_blog-card-meta-photo"
            v-lazy="
              require(`@/assets/images/why-us/management-philosophy-${
                index + 1
              }.png`)
            "
           
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["card"],
};
</script>
<style lang="scss" scoped>
.management-philosophy {
  position: relative;

  &:nth-child(1) {
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      right: -31px;
      background-image: url("../../../../../assets/images/core-service/core-top.png");
      background-size: 200px 200px;
      display: inline-block;
      width: 200px;
      height: 200px;
    }
  }

  @media (min-width: 900px) {
    padding: 70px 70px;
  }
  @media (min-width: 1024px) {
    padding: 70px 180px;
  }
  @media (min-width: 1900px) {
    padding: 100px 440px;
  }
  &:nth-child(3n - 1) {
    background-color: var(--bg-color-2);
    &::after {
      content: "";
      position: absolute;
      bottom: -90px;
      left: -15px;
      background-image: url("../../../../../assets/images/core-service/core-bottom.png");
      background-size: 200px 200px;
      display: inline-block;
      width: 200px;
      height: 200px;
    }
  }
  &:nth-child(even) {
    .management-philosophy_blog-card-text {
      order: 2;
    }
    .management-philosophy_blog-card-meta {
      order: 1;
    }
  }

  &_blog-card {
    display: flex;
    align-items: center;
    padding: 40px;
    gap: 50px;
    flex-direction: column;
    @media (min-width: 900px) {
      flex-direction: row;
    }

    &-text {
      flex: 0 0 50%;
      padding: 30px;
      padding-left: 0;
      display: flex;
      flex-direction: column;
      gap: 30px;
      &-title {
        color: var(--primary-color);
        font-style: var(--big-font-size);
        font-weight: 700;
      }
      &-description {
        color: var(--text-normal-color);
        font-style: var(--normal-font-size);
        font-weight: 400;
      }
    }
    &-meta {
      flex: 0 0 50%;
      &-photo {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>